require('./bootstrap');

window.Vue = require('vue');
import Vue from 'vue';
import Vuetify from 'vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

Vue.use(Vuetify)
const vuetify = new Vuetify();

Vue.use(VueTelInputVuetify, { vuetify });

//Home component
Vue.component('home', require('./components/home.vue').default)
Vue.component('admin-home', require('./components/home/adminHome.vue').default)

//Auth Components
Vue.component('auth-login', require('./components/auth/login.vue').default)
Vue.component('auth-reset', require('./components/auth/reset.vue').default)
Vue.component('auth-register', require('./components/auth/register.vue').default)
Vue.component('auth-logout', require('./components/auth/logout.vue').default)
Vue.component('auth-verify', require('./components/auth/verify.vue').default)


//Student components
Vue.component('student-index', require('./components/students/index.vue').default)

//Teachers components
Vue.component('teacher-index', require('./components/teachers/index.vue').default)
Vue.component('teacher-home', require('./components/teachers/home.vue').default)
Vue.component('teacher-payments', require('./components/teachers/payments.vue').default)
Vue.component('teacher-assigned-courses', require('./components/teachers/assignedCourses.vue').default)

//Courses components
Vue.component('course-index', require('./components/courses/index.vue').default)
Vue.component('course-select-course', require('./components/courses/selectCourse.vue').default)
Vue.component('course-mycourse', require('./components/courses/myCourse.vue').default)

//Institutes components
Vue.component('institute-index', require('./components/institutes/index.vue').default)

//Payments component
Vue.component('payment-index', require('./components/payments/index.vue').default)

//Invoices component
Vue.component('invoice-index', require('./components/invoices/index.vue').default)

//Referreds component
Vue.component('referred-index',require('./components/referreds/index.vue').default)

//guest components
Vue.component('guest-courses',require('./components/guest/courses.vue').default)
Vue.component('guest-exam', require('./components/guest/placementExam.vue').default);
Vue.component('guest-placement-tests', require('./components/guest/placementTests.vue').default);

//partnership components
Vue.component('partnership-home', require('./components/partnerships/home.vue').default)
Vue.component('partnership-index',require('./components/partnerships/index.vue').default)
Vue.component('partnership-payments', require('./components/partnerships/payments.vue').default)

//watch recording components
Vue.component('recordings-watch', require('./components/recordings/watch.vue').default)

//placement exams components
Vue.component('placement-exams-index', require('./components/placementExams/index.vue').default)
Vue.component('placement-exams-edit', require('./components/placementExams/edit.vue').default)

//waiting list components
Vue.component('waiting-list-index', require('./components/waitingList/index.vue').default)

//payments components
Vue.component('mercadopago', require('./components/payments/mercadopago.vue').default)

//
Vue.component('users-index', require('./components/users/index.vue').default)

const app = new Vue({
    el: '#app',
    vuetify : new Vuetify(),

    data: () => ({
        drawer:true,
        user_menu:false,
        notifications:false,
    }),

    beforeMount(){
        this.drawer = !this.$vuetify.breakpoint.mdAndDown
    },

    mounted(){
        console.log("%c\nNEUMANN INSTITUTE\n\n"+"%cATENCIÓN :\nEsta función del navegador está pensada para desarrolladores. Si alguien te indicó que copiaras y pegaras algo aquí para modificar o para 'hackear' el sistema, se trata de un fraude. Si lo haces, la administración será notificada.\n\n ",
                        "font-size: 40px; color: #008dd4 ; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: #000;", "font-size: medium")
        
    }
});
